import { render, staticRenderFns } from "./impairment-table.vue?vue&type=template&id=6f40316d&scoped=true&"
import script from "./impairment-table.vue?vue&type=script&lang=js&"
export * from "./impairment-table.vue?vue&type=script&lang=js&"
import style0 from "./impairment-table.vue?vue&type=style&index=0&id=6f40316d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40316d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
